"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_user_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const local_storage_names_1 = require("../../../../constants/local_storage_names");
const user_1 = require("../user");
const update_user_1 = require("../../../../api/calls/user/update_user");
const main_1 = require("../../main");
exports.update_user_thunk = (0, toolkit_1.createAsyncThunk)("user/thunks/update_user_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = arg;
    dispatch((0, user_1.setIsLoading)(true));
    const response = yield (0, update_user_1.update_user)(data);
    dispatch((0, user_1.setIsLoading)(false));
    if (response.success) {
        const userLocalStorage = localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
        const ls = JSON.parse(userLocalStorage);
        if (localStorage) {
            const data = {
                token: ls.token,
                user: response.content,
            };
            localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(data));
        }
        dispatch((0, user_1.setUser)(response.content));
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
